import AnchoredPopoverController from "../../controllers/anchored_popover_base";
import "./component.scss";

// All behavior lives in AnchoredPopoverController; this component only
// contributes its identifier (tooltip) and its dark-label SCSS.
export default class extends AnchoredPopoverController {}
